import { useBoundStore } from "../zustand/Store";

export const useCloseModal = () => {
    const updateIsVisible = useBoundStore((state) => state.updateIsVisible)
    const updateArticleId = useBoundStore((state) => state.updateArticleId);
    return () => {
        updateIsVisible(false);
        updateArticleId(null);
    }
};